module.exports = __webpack_public_path__ + "img/UMA-G.b5d75503.png";